export function hasOrgTypePermission(orgData, permissionValue) {
    if (!orgData.orgPermissions || !Array.isArray(orgData.orgPermissions)) {
        return false;
    }
    return orgData.orgPermissions.includes(permissionValue);
}